const swiper_01 = new Swiper("#swiper_01", {
  loop: true,
  speed: 1000,
  slidesPerView: 2,
  autoplay: {
    delay: 3000, 
  },
  navigation: {
    nextEl: ".swiper-button-next-swiper_01",
    prevEl: ".swiper-button-prev-swiper_01"
  },
  breakpoints: {
    900: {
      slidesPerView: 3,
    }
  }
});

const swiper_02 = new Swiper("#swiper_02", {
  loop: true,
  speed: 1000,
  slidesPerView: 2,
  autoplay: {
    delay: 3000, 
  },
  navigation: {
    nextEl: ".swiper-button-next-swiper_02",
    prevEl: ".swiper-button-prev-swiper_02"
  },
  breakpoints: {
    900: {
      slidesPerView: 3,
    }
  }
});